exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh3[data-v-54b21a74] {\n  font-weight: normal;\n  margin-top: 12px !important;\n}\n", ""]);

// exports
